<script lang="jsx">
import { foldl, is } from '../lib'
import ApprovedUser from './icons/ApprovedUser.vue'
import BannedUser from './icons/BannedUser.vue'
import NotApprovedUser from './icons/NotApprovedUser.vue'

const List = ({ items, keys: { id = 'id', title, meta = {} }, footer }) => {
  return (
    <transition-group name="grid" tag="ul" class="unstyled grid" mode="out-in">
      {items.map((item) => (
        <li class="card" key={item[id]}>
          <header>
            <h3 class="interactive-header">{typeof title === 'function' ? title(item) : item[title] || '-'}</h3>
          </header>
          <div class="meta">
            {meta.map(({ label, path, getter, transform = (x) => x }) => {
              const value = path
                ? foldl(path.split('.'), (acc, key) => (is(acc, Array) ? acc.map((subItem) => subItem[key]) : acc[key]), item)
                : getter(item)
              if (label === 'status') {
                if (item['is_suspended']) {
                  return (
                    <div className="user-status">
                      <div className="user-status-item banned-user-status">
                        <BannedUser />
                        <p>Banned User</p>
                      </div>
                    </div>
                  )
                } else if (item['is_verified']) {
                  return (
                    <div class="user-status">
                      <div class="user-status-item approved-user-status">
                        <ApprovedUser />
                        <p>Approved User</p>
                      </div>
                    </div>
                  )
                } else {
                  return (
                    <div className="user-status">
                      <div className="user-status-item not-approved-user-status">
                        <NotApprovedUser />
                        <p>Not Approved User</p>
                      </div>
                    </div>
                  )
                }
              } else {
                return (
                  path != null && (
                    <p>
                      {label && `${label}: `}
                      {is(value, Array) && is(transform(value, item), Array) ? (
                        <ul class="unstyled comma-separated">
                          {value.map((v) => (
                            <li>{v}</li>
                          ))}
                        </ul>
                      ) : (
                        <span>{transform(value, item)}</span>
                      )}
                    </p>
                  )
                )
              }
            })}
          </div>
          {footer && (
            <footer>
              <p>Actions:</p>
              {footer(item)}
            </footer>
          )}
        </li>
      ))}
    </transition-group>
  )
}
export default List
</script>
